import FrameworkUtils from 'utils/framework';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import CompareDrawer from 'components/Catalog/ProductGrid/CompareDrawer/CompareDrawer';
import CompareDrawerEN from 'components/Catalog/ProductGrid/CompareDrawer/locales/CompareDrawer_en_US.js';
import CompareDrawerFR from 'components/Catalog/ProductGrid/CompareDrawer/locales/CompareDrawer_fr_CA.js';

const { wrapHOC } = FrameworkUtils;
const { getLocalisedDataFromResource } = LanguageLocaleUtils;
const getText = getLocalisedDataFromResource(CompareDrawerEN, CompareDrawerFR);

const withCompareDrawerLocale = wrapHOC(WrappedComponent => {
    const CompareDrawerWithLocale = props => (
        <WrappedComponent
            {...props}
            getText={getText}
        />
    );

    return CompareDrawerWithLocale;
});

export default withCompareDrawerLocale(CompareDrawer);
